import { activeConditionsQuery } from '../planner/context';
import type { ProtocolSpec } from '../planner/plan';
import { obesityOngoingMeasurements } from './obesityOngoingMeasurements';

/**
 * The obesity ongoing-measurement protocol, ready for `planProtocol`. No variables: every action is
 * unconditional, so nothing needs deriving — but `activeConditionsQuery` is still listed, because
 * topic matching reads the patient's Conditions to find the topic this protocol belongs on.
 */
export const obesityOngoingMeasurementsProtocol: ProtocolSpec = {
  planDefinition: obesityOngoingMeasurements,
  valueSets: [],
  queries: [activeConditionsQuery],
  deriveVariables: () => ({}),
};
